export default __webpack_public_path__ + "c273b3beea9a0b88b80c5078c4138305.png";